module.exports = __webpack_public_path__ + "static/media/mask-group-2@2x.40dc77af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mask-group-2@2x.png
// module id = 587
// module chunks = 1